module.exports = __webpack_public_path__ + "img/mb-delete.3859c2e7.svg";